import { FC } from "react";
import MermaidViewer from "./MermaidViewer";
import MermaidViewerSafari from "./MermaidViewerSafari";

interface MermaidViewerWrapperProps {
  diagram: string;
  isDemo?: boolean;
  onServiceClick?: (serviceUrl: string) => void;
}

const MermaidViewerWrapper: FC<MermaidViewerWrapperProps> = ({ diagram, isDemo, onServiceClick }) => {
  // Detect Safari browser
  const isSafari = () => {
    if (typeof navigator === "undefined") return false;
    
    const userAgent = navigator.userAgent.toLowerCase();
    const isSafariBrowser = userAgent.includes("safari") &&
      !userAgent.includes("chrome") &&
      !userAgent.includes("chromium") &&
      !userAgent.includes("android");
    
    console.log("Browser detection - User Agent:", userAgent);
    console.log("Is Safari:", isSafariBrowser);
    
    return isSafariBrowser;
  };
  
  // Use Safari-specific component for Safari, regular component for others
  if (isSafari()) {
    return <MermaidViewerSafari diagram={diagram} isDemo={isDemo} onServiceClick={onServiceClick} />;
  }

  return <MermaidViewer diagram={diagram} isDemo={isDemo} onServiceClick={onServiceClick} />;
};

export default MermaidViewerWrapper;